import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user/user.store'
import campaign from './modules/campaign/campaign.store'
import scenario from './modules/scenario/scenario.store'
import qccampaign from './modules/qccampaign/qccampaign.store'
import debug from './modules/debug/debug.store'
import agent from './modules/agent/agent.store'
import { actionTypes } from './actionTypes'
import $const from "@/utils/const";

let types = actionTypes

Vue.use(Vuex)

const store = new Vuex.Store({
    state    : {
        isShowLoading: false,
        isDataLoading: false,
        navigation   : window.innerWidth > 1264,
        menu         : null,
        tourConsole  : true,
        version      : '',
        authenticationService:
            process.env.VUE_APP_AUTHENTICATION_SERVICE ||
            $const.authenticationService.FPT_ID
    },
    mutations: {
        [types.LOADING]          : (state, payload) => {
            state.isShowLoading = payload
        },
        [types.DATA_LOADING]     : (state, payload) => {
            state.isDataLoading = payload
        },
        [types.TOGGLE_NAVIGATION]: (state) => {
            state.navigation = !state.navigation
        },
        [types.NAVIGATION](state, val) {
            state.navigation = val
        },
        [types.VERSION](state, val) {
            state.version = val
        },
        [types.TOUR_CONSOLE](state, val) {
            state.tourConsole = val
        }
    },
    actions  : {
        [types.LOADING]          : (context, payload) => {
            context.commit(types.LOADING, payload)
        },
        [types.DATA_LOADING]     : (context, payload) => {
            context.commit(types.DATA_LOADING, payload)
        },
        [types.TOGGLE_NAVIGATION]: (context) => {
            context.commit(types.TOGGLE_NAVIGATION)
        },
        [types.NAVIGATION](context, payload) {
            context.commit(types.NAVIGATION, payload)
        },
        [types.TOUR_CONSOLE]     : (context, payload) => {
            context.commit(types.TOUR_CONSOLE, payload)
        }
    },
    modules  : {
        user,
        campaign,
        scenario,
        qccampaign,
        debug,
        agent,
    },
    getters  : {
        loading         : state => state.isShowLoading,
        dataLoading     : state => state.isDataLoading,
        profile         : state => state.user.profile,
        token           : state => state.user.token,
        projects        : state => state.user.projects,
        currentProjectId: state => state.user.currentProjectId,
        version         : state => state.version
    }
})

export default store
